import React from 'react'

import NoteView from 'components/Layout/NoteView'
import NotesDirectory from 'screens/NotesDirectory'

export default function ChannelShowLayout({ channelId, channelTitle }) {
  return (
    <NoteView>
      <div
        style={{ marginTop: 64 }}
        className="font-family-system font-weight-bold note-editor-title flexbox-grow placeholder-shade-30"
      >
        {channelTitle}
      </div>
      <div className="margin-top-medium">
        <NotesDirectory channelId={channelId} orderField="lastActivityAt" />
      </div>
    </NoteView>
  )
}
